import {ComponentProjectChecklistItem} from './component-project-checklist-item.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {TorchUser} from '../../../@users/models/torch-user.model';

export class ComponentProjectChecklists {
  id: number;
  projectId: number;
  checklistName: string;
  itemsChecked: number;
  createdBy: string;
  updated: Date;
  items: ComponentProjectChecklistItem[];
  creatorSubject: BehaviorSubject<TorchUser> = new BehaviorSubject<TorchUser>(null);

  set creator(newValue: Observable<TorchUser>) {
    if (!!newValue) {
      newValue.subscribe(profile => this.creatorSubject.next(profile));
    }
  }

  get totalItems() {
    return this.items.length;
  }

  constructor() {
    this.items = [];
    this.itemsChecked = 0;
    this.updated = new Date();
  }
}
